export default __webpack_public_path__ + "0628470654fffe5acf32fa6e3d760453.woff";